import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private readonly _activeCount = signal(0);

  readonly isLoading = computed(() => this._activeCount() > 0);

  show(): void {
    this._activeCount.update((c) => c + 1);
  }

  hide(): void {
    this._activeCount.update((c) => Math.max(0, c - 1));
  }
}
